var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "750" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("done")]),
                  _vm._v("Finalizar solicitudes ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs9: "" } }, [
                _vm._v(" " + _vm._s(_vm.form.nombre_unidad) + " ")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs6: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v("Listado de servidores publicos")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: { "open-on-hover": "", buttom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c("v-icon", _vm._g({}, on), [
                                            _vm._v("help_outline")
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "ayuda" },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "text-xs-center caption"
                                                },
                                                [
                                                  _c("strong", [
                                                    _c(
                                                      "p",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("help_outline")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "Solo puede finalizar las solicitudes"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "\n                            cuando todas las programaciones de los servidores\n                            públicos\n                          "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "\n                            del listado hayan sido aprobados por sus\n                            respectivos jefes\n                          "
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.listado_funcionarios,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  props.item.servidor_publico
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  dark: "",
                                                  color:
                                                    props.item
                                                      .id_estado_vacac_progra ==
                                                    54
                                                      ? "#de95f9"
                                                      : props.item
                                                          .id_estado_vacac_progra ==
                                                        72
                                                      ? "#fa8449"
                                                      : "#FF3400"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.estado)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("close")]),
                      _vm._v("\n          Cancelar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: this.bandera_aprobacion == false
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.aprobarProgramacion()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v("\n          Aprobar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a8ab03e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8ab03e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/FinalizarProgramacionesFuncionarios.vue
// module id = null
// module chunks = 